<div class="modal-header">
  <div>
    <h4 class="modal-title" id="modal-basic-title">Edit timesheet entry</h4>
    <span class="modal-title-running-time" *ngIf="isTimerRunning && currentTimer?.timesheetId === timesheetDetail.id">{{
      (editTimeSheetValuesChanged.isCategoryChanged ||
        editTimeSheetValuesChanged.isClientChanged ||
        editTimeSheetValuesChanged.isDescriptionChanged ||
        editTimeSheetValuesChanged.isMatterChanged ||
        editTimeSheetValuesChanged.isTimeEntryTypeChanged) &&
      !!timesheetDetail.lastLoggedTime
        ? lastLoggedTimeString
        : currentTimeString
    }}</span>
  </div>
  <button type="button" class="close" (click)="closeModal.emit()" aria-label="Close">
    <svg-icon name="modal-close-icon" class="icon"></svg-icon>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="editTimesheetEntry" class="edit-timesheet-form">
    <div class="row">
      <div class="col-sm-12">
        <div class="form-field form-field-select">
          <label for="editTimesheetTimeEntryType">Time Entry Type</label>
          <ng-select
            labelForId="editTimesheetTimeEntryType"
            [items]="timeEntryTypes"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="timeEntryTypeName"
            bindValue="id"
            placeholder="Time Entry"
            [clearable]="false"
            [ngModel]="selectedTimeEntryTypeEditTimesheetEntry"
            [ngModelOptions]="{ standalone: true }"
            (change)="timeEntryTypeSelected($event, true); checkIfTimeSheetEditValuesChanged()">
          </ng-select>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-field form-field-select">
          <label for="editTimesheetClient">Client</label>
          <ng-select
            labelForId="editTimesheetClient"
            [items]="clientListOfEditTimesheetEntry"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="clientName"
            bindValue="id"
            [(ngModel)]="selectedClientEditTimesheetEntry"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Select Client"
            [virtualScroll]="true"
            (change)="
              onClientSelectionChanged($event, true);
              getMattersByClientIdEditTimesheet();
              checkIfTimeSheetEditValuesChanged()
            "
            [disabled]="selectedTimeEntryTypeEditTimesheetEntry === 2">
          </ng-select>
          @if (isClientOnStop()) {
          <app-client-on-stop-warning [tooltipText]="specialRequirements()" [showLabel]="true">
          </app-client-on-stop-warning>
          }
        </div>
        <div
          class="no-matter-assigned-error automatic-time-entry"
          *ngIf="!isPreviouslySelectedClientExistTimesheetEdit">
          <mat-error
            >Matters for <u>{{ previouslySelectedClientNameTimesheetEdit }}</u> is not assigned to you.
          </mat-error>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-field form-field-select">
          <label for="editTimesheetMatter">Matter</label>
          <ng-select
            appendTo="body"
            labelForId="editTimesheetMatter"
            [items]="matterListOfEditTimesheetEntry"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="matterName"
            bindValue="id"
            [(ngModel)]="selectedMatterEditTimesheetEntry"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Select Matter"
            [virtualScroll]="true"
            (change)="
              getClientByMatterIDForTimesheetEdit($event);
              checkIfTimeSheetEditValuesChanged();
              checkIfRoundingApplies(
                this.selectedTimeEntryTypeEditTimesheetEntry,
                this.selectedClientEditTimesheetEntry ?? 0,
                $event?.id
              )
            "
            [disabled]="selectedTimeEntryTypeEditTimesheetEntry === 3">
          </ng-select>
          <mat-error *ngIf="selectedMatterEditTimesheetEntry && !isSelectedMatterEditTimesheetEntryActive"
            >Matter is inactive
          </mat-error>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-field form-field-select">
          <label for="editTimesheetHeadlinePracticeArea">Headline Practice Area</label>
          <ng-select
            labelForId="editTimesheetHeadlinePracticeArea"
            [items]="headLinePracticeAreaByMatterId"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="headlinePracticeAreaName"
            bindValue="id"
            [(ngModel)]="selectedHeadlinePracticeAreaEditTimesheetEntry"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Headline Practice Area"
            [virtualScroll]="true"
            [disabled]="true">
          </ng-select>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-field form-field-select">
          <label for="editTimesheetPhase">Phase</label>
          <ng-select
            labelForId="editTimesheetPhase"
            [items]="phaseByMatterId"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            [(ngModel)]="selectedPhaseEditTimesheetEntry"
            [disabled]="selectedTimeEntryTypeEditTimesheetEntry === 3"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Select Phase"
            [virtualScroll]="true">
          </ng-select>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-field form-field-select">
          <label for="editTimesheetCategory">Category</label>
          <ng-select
            labelForId="editTimesheetCategory"
            [items]="categoryListOfManualEntry"
            [multiple]="false"
            [closeOnSelect]="true"
            [searchable]="true"
            bindLabel="categoryName"
            bindValue="id"
            [(ngModel)]="selectedCategoryOfEditTimesheetEntry"
            [ngModelOptions]="{ standalone: true }"
            (change)="checkIfTimeSheetEditValuesChanged()"
            placeholder="Select Category">
          </ng-select>
        </div>
      </div>
      <div class="col-sm-12">
        <div
          class="form-field form-field-select desc-input form-filed-icon"
          [ngClass]="{ 'description-pattern-error': editTimesheetEntry.controls.description.hasError('pattern') }">
          <label for="editTimesheetDescription">Description</label>
          <textarea
            id="editTimesheetDescription"
            matInput
            formControlName="description"
            placeholder="Enter Description"
            name="description"
            rows="1"
            (keyup)="descriptionInputSubject.next(editTimesheetEntry.get('description')?.value)"></textarea>
          <svg-icon name="matter-icon" class="input-icon"></svg-icon>
          <mat-error
            *ngIf="
              editTimesheetEntry.controls.description.touched &&
              editTimesheetEntry.controls.description.hasError('descriptionRequired') &&
              !editTimesheetEntry.controls.description.hasError('invalidDescription')
            "
            >{{ validationMessages.descriptionRequired }}
          </mat-error>
          <mat-error
            *ngIf="
              editTimesheetEntry.controls.description.touched &&
              editTimesheetEntry.controls.description.hasError('limitExceeds') &&
              !editTimesheetEntry.controls.description.hasError('invalidDescription')
            "
            >{{ validationMessages.maxLength2000ForDescription }}
          </mat-error>
          <mat-error
            *ngIf="
              editTimesheetEntry.controls.description.touched &&
              !(
                editTimesheetEntry.controls.description.hasError('limitExceeds') ||
                editTimesheetEntry.controls.description.hasError('descriptionRequired')
              ) &&
              editTimesheetEntry.controls.description.hasError('invalidDescription')
            "
            >{{ validationMessages.allowedCharactersForDescription }}
          </mat-error>
        </div>
      </div>
      <!-- Continuing booking or new booking label -->
      @let timesheetValuesChanged =
        (editTimeSheetValuesChanged.isCategoryChanged ||
          editTimeSheetValuesChanged.isClientChanged ||
          editTimeSheetValuesChanged.isDescriptionChanged ||
          editTimeSheetValuesChanged.isMatterChanged ||
          editTimeSheetValuesChanged.isTimeEntryTypeChanged) &&
        !!timesheetDetail.lastLoggedTime;

      @if (endTimerParams.isEndTimerEdit) {
        @if (timesheetValuesChanged) {
          <div class="col-sm-12 timer-info-label">{{ validationMessages.timeNewBookingDetailsChanged }}</div>
        } @else {
          <div class="col-sm-12 timer-info-label">{{ validationMessages.timeContinuingBookingSameDetails }}</div>
        }
      }
      <div class="col-sm-12 flex gap-2">
        <div class="col-sm-6 pl-0 pr-0">
          <div class="form-field form-field-select form-filed-icon">
            <label for="editTimesheetTime"> Actual Time Spent </label>
            <input
              id="editTimesheetTime"
              matInput
              type="text"
              formControlName="time"
              [placeholder]="validationMessages.timeSheetTimePlaceholder"
              (input)="
                checkIfRoundingApplies(
                  this.selectedTimeEntryTypeEditTimesheetEntry,
                  this.selectedClientEditTimesheetEntry ?? 0,
                  this.selectedMatterEditTimesheetEntry
                )
              "
              name="time"
              [class.form-field-error]="
                (editTimesheetEntry.controls.time.touched &&
                  editTimesheetEntry.controls.time.hasError('isTimeInvalid')) ||
                (editTimesheetEntry.controls.time.touched &&
                  editTimesheetEntry.controls.time.hasError('isTimeExceeded'))
              " />
            <svg-icon
              [name]="
                isTimerRunning &&
                currentTimer?.timesheetId === timesheetDetail.id &&
                editTimesheetEntry.controls.time.disabled
                  ? 'clock-started-icon'
                  : 'clock-icon'
              "
              class="input-icon edit-timesheet-time-icon"
              [ngClass]="{
                'timer-stop-enabled':
                  isTimerRunning &&
                  currentTimer?.timesheetId === timesheetDetail.id &&
                  editTimesheetEntry.controls.time.disabled,
              }"
              (click)="stopRunningTimerFromTimeSheetEdit()"></svg-icon>
          </div>
          <div class="row col-sm-12">
      @if (
        (editTimesheetEntry.controls.time.touched && editTimesheetEntry.controls.time.value !== '' &&
          editTimesheetEntry.controls.time.hasError('isTimeInvalid'))
      ) {
        <mat-error class="error-label">{{ validationMessages.timeSheetTimeInvalidFormat }}</mat-error>
      }

      @if (
        (editTimesheetEntry.controls.time.touched && editTimesheetEntry.controls.time.value !== '' &&
          editTimesheetEntry.controls.time.hasError('isTimeExceeded'))
      ) {
        <mat-error class="error-label">{{ validationMessages.timeSheetTimeInvalid }}</mat-error>
      }
    </div>
        </div>
        <!-- @if (!endTimerParams.isEndTimerEdit) { -->
        <div class="col-sm-6 pl-0 pr-0">
          <div class="form-field form-field-select form-filed-icon">
            <label for="editTimesheetTimeSaved" class="flex gap-2 items-center">
              <div>Time Saved</div>
              <div class="new-pill rounded-xl bg-blue-100 text-blue-800 px-2 text-xs">NEW!</div>
              <mat-icon
                matTooltip="Record any time savings achieved through use of technology and/or AI tools."
                matTooltipPosition="above"
                class="text-slate-500 material-icons-outlined info-icon-small"
                >info</mat-icon
              >
            </label>
            <input
              id="editTimesheetTimeSaved"
              matInput
              type="text"
              formControlName="timeSaved"
              [placeholder]="validationMessages.timeSheetTimePlaceholder"
              (input)="
                checkIfRoundingApplies(
                  selectedTimeEntryTypeEditTimesheetEntry,
                  selectedClientEditTimesheetEntry,
                  selectedMatterEditTimesheetEntry
                )"
              name="timeSaved"
              [class.form-field-error]="
                editTimesheetEntry.controls.timeSaved.hasError('isTimeInvalid') ||
                editTimesheetEntry.controls.timeSaved.hasError('isTimeExceeded')" 
              />
          </div>
        </div>
      </div>
    </div>
    <div class="row col-sm-12">
      @if (
        (editTimesheetEntry.controls.timeSaved.touched && editTimesheetEntry.controls.timeSaved.value !== '' &&
          editTimesheetEntry.controls.timeSaved.hasError('isTimeInvalid'))
      ) {
        <mat-error class="error-label">{{ validationMessages.timeSheetTimeInvalidFormat }}</mat-error>
      }

      @if (
        (editTimesheetEntry.controls.timeSaved.touched && editTimesheetEntry.controls.timeSaved.value !== '' &&
          editTimesheetEntry.controls.timeSaved.hasError('isTimeExceeded'))
      ) {
        <mat-error class="error-label">{{ validationMessages.timeSheetTimeInvalid }}</mat-error>
      }
    </div>
    <div>
        <div class="form-field form-field-select">
        <div class="label">
          <label for="selectTechonologiesUsedTimesheetEdit" class="flex gap-2 items-center">
            <div>Technologies Used</div>
            <mat-icon
                matTooltip="Select technologies used to achieve time savings."
                matTooltipPosition="right"
                class="text-slate-500 material-icons-outlined info-icon-small"
              >info</mat-icon>
          </label>
        </div>
        <ng-select
          labelForId="selectTechonologiesUsed"
          formControlName="techUsed"
          [items]="technologies.result"
          [multiple]="true"
          [closeOnSelect]="true"
          [searchable]="true"
          bindLabel="techUsed"
          bindValue="id"
          placeholder="Select Technology"
          class="multiline-option-content"
          [class.form-field-error]="editTimesheetEntry.controls.timeSaved.touched &&
                !editTimesheetEntry.controls.timeSaved.hasError('isTimeInvalid') && 
                !editTimesheetEntry.controls.timeSaved.hasError('isTimeExceeded') && 
                editTimesheetEntry.controls.timeSaved.value !== '' &&
                editTimesheetEntry.controls.techUsed.value.length === 0 && 
                editTimesheetEntry.controls.techUsed.enabled
                "
          >
          </ng-select>
      </div>
       @if ((editTimesheetEntry.controls.timeSaved.touched && !editTimesheetEntry.controls.timeSaved.hasError('isTimeInvalid') && 
            !editTimesheetEntry.controls.timeSaved.hasError('isTimeExceeded') && editTimesheetEntry.controls.timeSaved.value !== '') && 
            (editTimesheetEntry.controls.techUsed.value.length === 0 && editTimesheetEntry.controls.techUsed.enabled)) {
              <mat-error class="error-label">{{validationMessages.noTechnologySelected}}</mat-error>
          } 
    </div>
    <div class="row">
      <div class="total-billed-time col-sm-12 flex gap-2 align-items-center justify-between">
        <div>Total Time Entry</div>
        <div class="flex gap-2 align-items-center">
          <div class="label">{{ totalBilledTimeRounded }}</div>
          @if (showRoundingApplied()) {
            <svg-icon
              name="rounded"
              class="icon"
              matTooltip="Unrounded hours: {{ totalBilledTime }}"
              matTooltipPosition="above"></svg-icon>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <button
          type="button"
          class="btn btn-lg"
          [disabled]="
            !editTimesheetEntry.valid ||
            (selectedMatterEditTimesheetEntry && !isSelectedMatterEditTimesheetEntryActive) ||
            (!selectedCategoryOfEditTimesheetEntry &&
              selectedTimeEntryTypeEditTimesheetEntry !== timeSheetTimeEntryTypeIDs.TempTime) ||
            (!selectedMatterEditTimesheetEntry &&
              selectedTimeEntryTypeEditTimesheetEntry !== timeSheetTimeEntryTypeIDs.TempTime) ||
            (!selectedClientEditTimesheetEntry &&
              selectedTimeEntryTypeEditTimesheetEntry !== timeSheetTimeEntryTypeIDs.TempTime)
          "
          (click)="stopRunningTimerSaveTimesheetDetails()">
          Save
        </button>
      </div>
      <div class="col-sm-6">
        <button type="button" class="btn btn-lg btn-outline" (click)="cancelEditTimeSheet()">Cancel</button>
      </div>
    </div>
  </form>
</div>
